import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

// Create the React plugin instance
const reactPlugin = new ReactPlugin();

// Initialize Application Insights
const appInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.REACT_APP_INSIGHTS_CONN_STRING,
        enableAutoRouteTracking: true, // Automatically track route changes in React Router
        enableCorsCorrelation: true, // Enable correlation with backend requests
        enableRequestHeaderTracking: true, // Track request headers
        enableResponseHeaderTracking: true, // Track response headers
        enableAjaxPerfTracking: true, // Track AJAX performance
        enableUnhandledPromiseRejectionTracking: true, // Track unhandled promise rejections
        disableAjaxTracking: false, // Enable AJAX call tracking
        disableFetchTracking: false, // Enable Fetch API tracking
        enableDebug: false, // Set to true for debugging
        loggingLevelConsole: 0, // 0 = OFF, 1 = ERROR, 2 = WARNING
        loggingLevelTelemetry: 2, // 0 = OFF, 1 = CRITICAL, 2 = ERROR
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: {}
        }
    }
});

// Load Application Insights
appInsights.loadAppInsights();

// Track the initial page view
appInsights.trackPageView();

export { reactPlugin, appInsights };
